import $ from 'jquery'
import 'jquery-ui';
// import ApexCharts from "apexcharts/dist/apexcharts.js";


const script = $(document).ready(function () {


    $(document).on('click', '.note-edit', function () {
        $(this).find('.note-edit-dropdown').toggleClass('active');
    });


    $(document).on('click', '.dropdown-menu ul li', function () {
        $(this).siblings('li').removeClass('active');
        $(this).siblings('li').removeClass('selected');
        $(this).siblings('li').children('a').removeClass('active');
        $(this).siblings('li').children('a').removeClass('selected');
    });

    $('.screen-tools button').each(function () {
        $(this).click(function () {
            let eventValue = $(this).attr('class');
            let eventName = $(this).parents('.sidebar').attr('id');
            $('#changePage').find("input[name='effect']").attr('value', eventValue);
            $('#changePage').find("input[name='page']").attr('value', eventName);
            $('#changePage').submit();
        });
    });

    $(document).on('click','.screen-tools button', function () {
        if ($(this).attr('class') == 'minimize' || $(this).attr('class') == 'maximize') {
            $(this).parents('.sidebar').toggleClass('minimized');
            $(this).toggleClass('maximize');
            $(this).toggleClass('minimize');
            const sidebarWidth = '241px';
            if ($('.sidebar.sidebar-1').hasClass('minimized') && $('.sidebar.sidebar-2').hasClass('minimized')) {
                $(this).parents('.wrapper').css('grid-template-columns', '48px 48px auto');
            } else if ($('.sidebar.sidebar-1').hasClass('minimized') && !$('.sidebar.sidebar-2').hasClass('minimized')) {
                $(this).parents('.wrapper').css('grid-template-columns', '48px ' + sidebarWidth + ' auto');
            } else if ($('.sidebar.sidebar-2').hasClass('minimized') && !$('.sidebar.sidebar-1').hasClass('minimized')) {
                $(this).parents('.wrapper').css('grid-template-columns', sidebarWidth + ' 48px auto');
            } else if (!$('.sidebar.sidebar-1').hasClass('minimized') && !$('.sidebar.sidebar-2').hasClass('minimized')) {
                $(this).parents('.wrapper').css('grid-template-columns', sidebarWidth + ' ' + sidebarWidth + ' auto');
            }
        }
    });


    $(document).on('loaded.bs.select', ".form-field select", function () {
        $(this).parents('.bootstrap-select').addClass($(this).attr('name'));
    });

    // ------------------------
    $(document).on('click','.approve',function(){
        $(this).parents('td').find('.approve').hide();
        $(this).parents('td').find('.remove').hide();
        //$(this).parents('td').find('span.info_window').text($(this).parents('td').find('textarea').val());
        $(this).parents('td').find('textarea').hide();
        $(this).parents('td').find('textarea').removeClass('active');
    });
    $(document).on('click','.infos tr td .info_window',function(){
        const textarea = $('.infos tr td textarea.active');
        if(textarea.length === 0) {
           let infoHeight = $(this).height();
           $(this).parents('td').find('textarea').addClass('active');
           $(this).parents('td').find('textarea').css({"display": "block", "top": infoHeight});
           $(this).parents('td').find('.approve').show();
           $(this).parents('td').find('.remove').show();
        }

    });
    $(document).on('click','#study_main tr td .info_window',function(){
        const textarea = $('#study_main tr td textarea.active');
        if(textarea.length === 0) {
            let infoHeight = $(this).height();
            $(this).parents('td').find('textarea').addClass('active');
            $(this).parents('td').find('textarea').css({"display": "block", "top": infoHeight});
            $(this).parents('td').find('.approve').show();
            $(this).parents('td').find('.remove').show();
        }
    });
    $(document).on('click','.remove',function(){
        $(this).parents('td').find('.selectpicker').selectpicker('val', 'New');
        $(this).parents('td').find('.approve').hide();
        $(this).parents('td').find('.remove').hide();
        $(this).parents('td').find('textarea').hide();
        $(this).parents('td').find('textarea').removeClass('active');
    });
    $(document).on('changed.bs.select','.infos .selectpicker, #study_main .selectpicker', function () {
        $(this).parents('td').find('.approve').show();
        $(this).parents('td').find('.remove').show();
    });

    // ------------------------
    $(document).on('click','.dropdown-menu', function(e){
        e.stopPropagation();
    });

    $(document).on('apply.daterangepicker','input.datepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('DD.MM.YYYY') + ' - ' + picker.endDate.format('DD.MM.YYYY'));
    });
    $(document).on('cancel.daterangepicker','input.datepicker', function() {
        $(this).val($(this).val());
    });

    $('span.datepicker').daterangepicker({
        singleDatePicker: true,
        autoUpdateInput: false,
        opens: 'left',
        showDropdowns: false,
        locale: {
            format: 'DD.MM.YYYY'
        },
    }, function() {
    });

    $(document).on('apply.daterangepicker','span.datepicker', function(ev, picker) {
        $(this).text(picker.startDate.format('DD.MM.YYYY'));
    });
    $(document).on('cancel.daterangepicker','span.datepicker', function() {
        $(this).text($(this).text());
    });

    //var fuckingHeight = $('.lists.scrolling').height();

    // Patient gallery drag and drop
    $(document).on('click','.gallery-images figure', function(){
        if( $(this).attr('class') !== 'active' ){
            $(this).addClass('active').siblings().removeClass('active');
            $('.gallery-preview').removeClass('dragged').addClass('active');
            $('.gallery_preview .dragged-image').remove();
        }
    });

    // Permissions checkboxes check or uncheck all
    $(document).on('change','.form-checkboxes-field input[id*="all_"]', function () {
       const checkboxes_field = $(this).closest('.form-checkboxes-field');
        if (this.checked) {
            checkboxes_field.find('label').each(function () {
                $(this).find('span').addClass('checked');
                $(this).find('input').prop('checked', true);
            });
        } else {
            checkboxes_field.find('label').each(function () {
                $(this).find('span').removeClass('checked');
                $(this).find('input').prop('checked', false);
            });
        }
    });
    $(document).on('shown.bs.modal','.modal-new-user', function () {
        $(this).find('.form-checkboxes-field').each(function () {
            const checkboxes_fields = $(this);
            checkboxes_fields.find('input:not([id*="all_"])').on('change', function () {
                let p_checkboxes_length = $(this).parents('.form-checkboxes-field').find('input').length - 1;
                let checkboxes_field = $(this).parents('.form-checkboxes-field');
                if (checkboxes_field.find('label[for*="all_"] span').hasClass('checked')) {
                    if (checkboxes_field.find('input:checked').length - 1 < p_checkboxes_length) {
                        checkboxes_field.find('label[for*="all_"] span').removeClass('checked');
                        checkboxes_field.find('input[id*="all_"]').prop('checked', false);
                    }
                } else {
                    if (checkboxes_field.find('input:checked').length == p_checkboxes_length) {
                        checkboxes_field.find('label[for*="all_"] span').addClass('checked');
                        checkboxes_field.find('input[id*=all_"]').prop('checked', true);
                    }
                }
            });
        });
    });

    $.fn.visibleHeight = function() {
        var elBottom, elTop, scrollBot, scrollTop, visibleBottom, visibleTop;
        scrollTop = $(window).scrollTop();
        scrollBot = scrollTop + $('body').outerHeight();
        elTop = this.offset().top;
        elBottom = elTop + this.outerHeight();
        visibleTop = elTop < scrollTop ? scrollTop : elTop;
        visibleBottom = elBottom > scrollBot ? scrollBot : elBottom;
        return visibleBottom - visibleTop;
    }

});

export default script;
